class ConsoleDebug {
    public static displayOps: boolean = false;

    public static init(): void {
        ConsoleDebug.displayOps = false;
    }
}

export { ConsoleDebug };
